import { render, staticRenderFns } from "./designPreview.vue?vue&type=template&id=107524f4&"
import script from "./designPreview.vue?vue&type=script&lang=ts&"
export * from "./designPreview.vue?vue&type=script&lang=ts&"
import style0 from "./designPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports